<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent"> </p>
<p class="noindent"> </p>
<p class="center1"><a id="page_iii"></a>Also by Zakes Mda</p>
<p class="center"><em>The Madonna of Excelsior<br/>She Plays with Darkness<br/>Ways of Dying</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter02.vue?eefc143e